module.exports = __webpack_public_path__ + "static/img/bedsore.cc98e77e.svg";